export const UPLOAD_FILES_FIELD_NAME = '_uploadFiles'
export const MEDIA_UPLOADER_ID = '_MEDIA_UPLOADER_ID'
